import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import './AdminPage.css';
/**
 * 管理画面メインコンポーネント
 */
const AdminPage = ({ t }) => {
    const [rooms, setRooms] = useState([]);
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [participants, setParticipants] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        loadRooms();
    }, []);
    useEffect(() => {
        if (selectedRoom) {
            loadParticipants(selectedRoom);
        }
    }, [selectedRoom]);
    const loadRooms = async () => {
        try {
            const response = await fetch('/api/admin/rooms');
            const data = await response.json();
            setRooms(data);
        }
        catch (error) {
            console.error('Failed to load rooms:', error);
        }
        finally {
            setLoading(false);
        }
    };
    const loadParticipants = async (roomId) => {
        try {
            const response = await fetch(`/api/admin/rooms/${roomId}/participants`);
            const data = await response.json();
            setParticipants(data);
        }
        catch (error) {
            console.error('Failed to load participants:', error);
        }
    };
    const handleRoomDelete = async (roomId) => {
        if (!confirm(t('admin.confirmDeleteRoom'))) {
            return;
        }
        try {
            await fetch(`/api/admin/rooms/${roomId}`, {
                method: 'DELETE'
            });
            await loadRooms();
            if (selectedRoom === roomId) {
                setSelectedRoom(null);
                setParticipants([]);
            }
        }
        catch (error) {
            console.error('Failed to delete room:', error);
        }
    };
    const handleParticipantKick = async (participantId) => {
        if (!selectedRoom || !confirm(t('admin.confirmKickParticipant'))) {
            return;
        }
        try {
            await fetch(`/api/admin/rooms/${selectedRoom}/participants/${participantId}/kick`, {
                method: 'POST'
            });
            await loadParticipants(selectedRoom);
        }
        catch (error) {
            console.error('Failed to kick participant:', error);
        }
    };
    const handleModeratorToggle = async (participantId, makeModerator) => {
        if (!selectedRoom) {
            return;
        }
        try {
            await fetch(`/api/admin/rooms/${selectedRoom}/participants/${participantId}/moderator`, {
                method: makeModerator ? 'POST' : 'DELETE'
            });
            await loadParticipants(selectedRoom);
        }
        catch (error) {
            console.error('Failed to toggle moderator:', error);
        }
    };
    if (loading) {
        return (React.createElement("div", { className: "admin-page" },
            React.createElement("div", { className: "admin-loading" },
                React.createElement("div", { className: "spinner" }),
                React.createElement("p", null, t('admin.loading')))));
    }
    return (React.createElement("div", { className: "admin-page" },
        React.createElement("div", { className: "admin-header" },
            React.createElement("h1", null, t('admin.title')),
            React.createElement("button", { className: "refresh-btn", onClick: loadRooms }, t('admin.refresh'))),
        React.createElement("div", { className: "admin-content" },
            React.createElement("div", { className: "admin-sidebar" },
                React.createElement("h2", null,
                    t('admin.rooms'),
                    " (",
                    rooms.length,
                    ")"),
                React.createElement("div", { className: "room-list" }, rooms.map(room => (React.createElement("div", { key: room.id, className: `room-item ${selectedRoom === room.id ? 'selected' : ''}`, onClick: () => setSelectedRoom(room.id) },
                    React.createElement("div", { className: "room-header" },
                        React.createElement("h3", null, room.name),
                        React.createElement("span", { className: `room-status ${room.isActive ? 'active' : 'inactive'}` }, room.isActive ? t('admin.active') : t('admin.inactive'))),
                    React.createElement("div", { className: "room-info" },
                        React.createElement("span", null,
                            t('admin.participants'),
                            ": ",
                            room.participants),
                        React.createElement("span", null,
                            t('admin.created'),
                            ": ",
                            new Date(room.createdAt).toLocaleDateString())),
                    React.createElement("div", { className: "room-actions" },
                        React.createElement("button", { className: "delete-btn", onClick: (e) => {
                                e.stopPropagation();
                                handleRoomDelete(room.id);
                            } }, t('admin.delete')))))))),
            React.createElement("div", { className: "admin-main" }, selectedRoom ? (React.createElement("div", { className: "room-details" },
                React.createElement("h2", null, t('admin.roomDetails')),
                React.createElement("div", { className: "participants-list" },
                    React.createElement("h3", null,
                        t('admin.participants'),
                        " (",
                        participants.length,
                        ")"),
                    React.createElement("div", { className: "participants-table" },
                        React.createElement("div", { className: "table-header" },
                            React.createElement("span", null, t('admin.name')),
                            React.createElement("span", null, t('admin.role')),
                            React.createElement("span", null, t('admin.joinTime')),
                            React.createElement("span", null, t('admin.actions'))),
                        participants.map(participant => (React.createElement("div", { key: participant.id, className: "participant-row" },
                            React.createElement("span", { className: "participant-name" }, participant.name),
                            React.createElement("span", { className: `participant-role ${participant.isModerator ? 'moderator' : 'participant'}` }, participant.isModerator ? t('admin.moderator') : t('admin.participant')),
                            React.createElement("span", { className: "participant-join-time" }, new Date(participant.joinTime).toLocaleString()),
                            React.createElement("div", { className: "participant-actions" },
                                React.createElement("button", { className: `moderator-btn ${participant.isModerator ? 'remove' : 'make'}`, onClick: () => handleModeratorToggle(participant.id, !participant.isModerator) }, participant.isModerator
                                    ? t('admin.removeModerator')
                                    : t('admin.makeModerator')),
                                React.createElement("button", { className: "kick-btn", onClick: () => handleParticipantKick(participant.id) }, t('admin.kick')))))))))) : (React.createElement("div", { className: "no-selection" },
                React.createElement("p", null, t('admin.selectRoom'))))))));
};
/**
 * Maps parts of the redux state to the props of this component.
 */
function mapStateToProps(state) {
    return {};
}
export default translate(connect(mapStateToProps)(AdminPage));
